import React, { useEffect, useState } from "react";
import { Image, InputGroup, Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { AddToolTip } from "../../../components";

const SelectFields = ({
  fields = [],
  values,
  setValues,
  setselectFields,
  selectFields,
  setFieldValue,
}) => {
  const [searchBar, setsearchBar] = useState("");
  const [cross, showcross] = useState(false);
  return (
    <div style={{ zIndex: "1" }}>
      <div
        className="d-flex  align-items-center border-bottom"
        style={{
          paddingBottom: "20px",
          paddingTop: "20px",
          marginBottom: "20px",
        }}
      >
        <p className="font-weight-bold p-0 m-0" style={{ fontSize: "16px" }}>
          Select fields
        </p>
        <button
          className=" ml-auto btn btn-secondary"
          onClick={() => {
            setselectFields(false);
          }}
          variant="secondary"
          type="button"
        >
          Close
          {/* <FontAwesomeIcon
            icon={faTimes}
            style={{
              color: "#C4061A",
              fontSize: "20px",
            }}
            size={"sm" || "2x"}
          /> */}
        </button>
      </div>
      <div style={{ fontSize: "12px" }}>
        <p className="pb-1 m-0" style={{ fontSize: "14px", fontWeight: "500" }}>
          Select field
        </p>
        <Form>
          <InputGroup className="d-flex w-100 border-1 rounded">
            <Form.Control
              // {...rest}
              size="sm"
              id="source-search-box"
              className="border-0"
              placeholder="Search source fields here"
              onChange={(event) => {
                setsearchBar(event.target.value);
                event.target.value == "" ? showcross(false) : showcross(true);
              }}
              // onKeyPress={onKeyPress}
              //   onFocus={onMouseOut}
              type="text"
              value={searchBar}
            />

            {cross ? (
              <button
                style={{ backgroundColor: "inherit" }}
                className="border-0"
                onClick={() => {
                  setsearchBar("");
                  showcross(false);
                }}
                type="button"
              >
                <FontAwesomeIcon icon={faTimes} size={"sm" || "2x"} />
              </button>
            ) : (
              <></>
            )}
          </InputGroup>
        </Form>
        <div
          className="p-1"
          style={{
            overflow: "scroll",
            height: "67vh",
            width: "21.875rem",
          }}
        >
          {fields &&
            fields.map((element, index) => {
              const indexOfElement = values.aggregationEntites
                .map((el) => el.fieldName)
                .indexOf(element.fieldName);
              const isSelected = indexOfElement != -1 ? true : false;
              const show_element = (item) => {
                if (searchBar == "") {
                  return true;
                } else if (
                  item.fieldName
                    ? item.fieldName
                        .toLowerCase()
                        .includes(searchBar.toLowerCase())
                    : false
                ) {
                  return true;
                }
              };
              if (show_element(element)) {
                return (
                  <div className="d-flex">
                    <input
                      className="mr-3 check select-checkBox"
                      type="checkbox"
                      value=""
                      onChange={() => {
                        // let newfields = [...fields];
                        // newfields[index]["selected"] = !newfields[index][
                        //   "selected"
                        // ];
                        // setfields(newfields);
                        if (isSelected) {
                          let temp = [...values.aggregationEntites];
                          temp.splice(indexOfElement, 1);
                          setFieldValue("aggregationEntites", temp);
                        } else {
                          let temp = [...values.aggregationEntites];
                          temp.push(element);
                          setFieldValue("aggregationEntites", temp);
                        }
                      }}
                      checked={isSelected}
                    ></input>
                    <p
                      className=" p-2 m-0 border-bottom"
                      style={{
                        width: "90%",
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#333333",
                      }}
                    >
                      <AddToolTip
                        name={
                          element.fieldName[0] == "/"
                            ? element.fieldName.substring(1)
                            : element.fieldName
                        }
                      />
                    </p>
                  </div>
                );
              }
            })}
        </div>
      </div>
    </div>
  );
};

export default SelectFields;
